import { yupResolver } from "@hookform/resolvers/yup";
import { CloudCustomerAddress } from "@omni/types/api/customer/cloud/address.model";
import { AddressType } from "@omni/types/api/customer/cloud/shared/enums/addressType.enum";
import { AddressValidationStatus } from "@omni/types/api/customer/cloud/shared/enums/addressValidationStatus.enum";
import * as yup from "yup";

import { CustomerAddressFormBlock } from "@/components/Form/RHF/FormBlocks/Address/addressFormBlock.container";
import { RequiredCustomerDeliveryAddressValidationSchema } from "@/components/Form/RHF/FormBlocks/Address/addressFormBlock.schema";
import { parseToBPostFieldAddress } from "@/components/Form/RHF/FormFields/BPostAddressField/helpers/address.helper";
import { HiddenField } from "@/components/Form/RHF/FormFields/HiddenField/hiddenField.component";
import { useOmniForm } from "@/components/Form/RHF/Utils/useOmniForm";
import { OmniFormContextProvider } from "@/utils/forms/omniForm.provider";

const EditDeliveryAddressValidationSchema = yup
    .object({
        id: yup.string().required()
    })
    .concat(RequiredCustomerDeliveryAddressValidationSchema);

type EditDeliveryAddressFormValues = yup.InferType<
    typeof EditDeliveryAddressValidationSchema
>;

type DeliveryAddressFormProps = {
    address: CloudCustomerAddress;
    formId: string;
    skipValidation?: boolean;
    onFormSubmit: (
        data: CloudCustomerAddress,
        isBPostField: boolean
    ) => Promise<void>;
};

const EditDeliveryAddressForm = ({
    address,
    formId,
    skipValidation = false,
    onFormSubmit
}: DeliveryAddressFormProps) => {
    const methods = useOmniForm({
        mode: "onBlur",
        reValidateMode: "onBlur",
        defaultValues: {
            id: address.id,
            delivery: parseToBPostFieldAddress(address)
        },
        resolver: yupResolver(EditDeliveryAddressValidationSchema)
    });

    const onSubmit = (data: EditDeliveryAddressFormValues) => {
        const customerAddress = {
            ...address,
            ...data.delivery,
            box: data.delivery.box || "",
            addressing: data.delivery.addressing || ""
        } satisfies CloudCustomerAddress;

        onFormSubmit(customerAddress, !!data.delivery.selected);
    };

    return (
        <OmniFormContextProvider {...methods}>
            <form
                id={formId}
                onSubmit={methods.handleSubmit(onSubmit)}
            >
                <HiddenField<EditDeliveryAddressFormValues> name="id" />
                <CustomerAddressFormBlock<
                    EditDeliveryAddressFormValues,
                    AddressType.Delivery
                >
                    skipValidation={skipValidation}
                    addressType={AddressType.Delivery}
                    country={address.country}
                    addressStatus={
                        address.validationStatus ||
                        AddressValidationStatus.Unknown
                    }
                />
            </form>
        </OmniFormContextProvider>
    );
};

export { EditDeliveryAddressForm };
